import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import ButtonIconPicker from 'client/components/core/Sidebar/components/Settings/components/ButtonIconPicker'
import { useUpdateFormElementProp } from '../../hooks/use-update-form-element-prop'
import {
  FormInterface,
  FormSubmitButtonInterface,
} from 'src/shared/types/entities/form-interface'

export interface ButtonSettingsProps {
  formEntity: FormInterface
  submitButton: FormSubmitButtonInterface
}

export const FormElementSubmitButtonSettings = ({
  formEntity,
  submitButton,
}: ButtonSettingsProps) => {
  const { t } = useTranslation()

  const updateProp = useUpdateFormElementProp(formEntity, submitButton)

  return (
    <React.Fragment>
      <TextInputControl
        wrapperProps={{
          labelText: t('entity_settings.button.button_text.label'),
        }}
        value={submitButton.text}
        update={updateProp('text')}
      />
      <TextInputControl
        wrapperProps={{
          labelText: 'entity_settings.button.sub_text.label',
        }}
        update={updateProp('subText')}
        value={submitButton.subText}
      />
      <ButtonIconPicker
        valueBefore={submitButton.iconClassNameBefore}
        valueAfter={submitButton.iconClassNameAfter}
        updateBefore={updateProp('iconClassNameBefore')}
        updateAfter={updateProp('iconClassNameAfter')}
      />
      <HtmlAttrId attrId={submitButton.htmlAttrId} />
    </React.Fragment>
  )
}
